import { Component } from "react";
import React from "react";
import "./PrivacyPolicy.css";
import {
  Box,
  Typography,
  Container,
} from "@mui/material";
import Navbar from "../../Nav/Components/Navbar";
import Footer from "../../Footer/Component/Footer";


class PrivacyPolicy extends Component {
  render() {
    return (
      <div id="privacy-container">

        <Navbar />

        {/* Banner Section */}
        <div id="privacy-banner">
          <div id="privacy-overlay">
            <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                color: "white",
                textAlign: "center",
                fontSize: { xs: "28px", sm: "45px", md: "60px" },
                fontFamily:
                  "Gill Sans, Gill Sans MT, Calibri, sans-serif",
              }}
            >
              PRIVACY POLICY
            </Typography>
          </div>
        </div>

        {/* Content Section */}
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#D12230",
              mb: 3,
              textAlign: "center",
            }}
          >
            Privacy Policy - Central Kia
          </Typography>

          <Typography sx={textStyle}>
            At Central Kia, we value your privacy and are committed to
            protecting your personal information. This Privacy Policy
            explains how we collect, use, store, and protect the
            information shared by users through our website.
          </Typography>

          <Typography sx={textStyle}>
            By accessing or using our website, you agree to the terms
            mentioned in this Privacy Policy.
          </Typography>

          <SectionTitle title="Information We Collect" />

          <ul style={listStyle}>
            <li>Name</li>
            <li>Mobile Number</li>
            <li>Email Address</li>
            <li>City / Location</li>
            <li>Vehicle Preferences</li>
            <li>Test Drive or Service Requests</li>
            <li>
              Any other information voluntarily submitted through forms
            </li>
          </ul>

          <SectionTitle title="How We Use Your Information" />

          <ul style={listStyle}>
            <li>Responding to your inquiries</li>

            <li>
              Scheduling test drives or service appointments
            </li>

            <li>
              Providing vehicle information and offers
            </li>

            <li>Improving customer experience</li>

            <li>
              Marketing and promotional communication via Call,
              SMS, WhatsApp, or Email
            </li>

            <li>
              Internal analytics and business operations
            </li>
          </ul>

          <SectionTitle title="Data Protection & Security" />

          <Typography sx={textStyle}>
            We implement appropriate security measures to safeguard
            your personal information against unauthorized access,
            misuse, disclosure, or alteration.
          </Typography>

          <SectionTitle title="Sharing of Information" />

          <Typography sx={textStyle}>
            Central Kia does not sell, trade, or rent your personal
            information to third parties.
          </Typography>

          <Typography sx={textStyle}>
            However, your information may be shared with:
          </Typography>

          <ul style={listStyle}>
            <li>Authorized Kia representatives</li>

            <li>
              Service providers assisting us in business operations
            </li>

            <li>
              Government or legal authorities when required under
              applicable law
            </li>
          </ul>

          <SectionTitle title="Cookies Policy" />

          <Typography sx={textStyle}>
            Our website may use cookies to improve user experience
            and analyze website traffic.
          </Typography>

          <SectionTitle title="Third-Party Links" />

          <Typography sx={textStyle}>
            Our website may contain links to third-party websites.
            Central Kia is not responsible for the privacy practices
            or content of such external websites.
          </Typography>

          <SectionTitle title="User Consent" />

          <Typography sx={textStyle}>
            By submitting your information on our website or Meta
            Instant Forms, you consent to the collection and use of
            your data in accordance with this Privacy Policy.
          </Typography>

          <Typography sx={textStyle}>
            You also authorize Central Kia to contact you regarding
            vehicle inquiries, offers, dealership communication,
            test drives, and customer support services via Call,
            SMS, WhatsApp, or Email.
          </Typography>

          <SectionTitle title="Your Rights" />

          <ul style={listStyle}>
            <li>Access your personal data</li>

            <li>Correct inaccurate information</li>

            <li>
              Withdraw consent for marketing communication
            </li>

            <li>
              Request deletion of your information (subject to
              legal obligations)
            </li>
          </ul>

          <SectionTitle title="Contact Us" />

          <Typography sx={textStyle}>
            Central Kia
          </Typography>

          <Typography sx={textStyle}>
            Website: https://centralkia.co.in/
          </Typography>

          <Typography sx={textStyle}>
            Email: digitalsales@centralkia.in
          </Typography>

          <Typography sx={textStyle}>
            Phone: +91 9237301652
          </Typography>

          <SectionTitle title="Policy Updates" />

          <Typography sx={textStyle}>
            Central Kia reserves the right to modify or update this
            Privacy Policy at any time without prior notice.
          </Typography>

          <Typography
            sx={{
              ...textStyle,
              fontWeight: "bold",
              mt: 4,
            }}
          >
            Last Updated: May 2026
          </Typography>
        </Container>

        <Footer />
      </div>
    );
  }
}

const SectionTitle = ({ title }) => (
  <Typography
    variant="h5"
    sx={{
      fontWeight: "bold",
      color: "#D12230",
      mt: 5,
      mb: 2,
      fontFamily: "Gill Sans, Gill Sans MT, Calibri, sans-serif",
    }}
  >
    {title}
  </Typography>
);

const textStyle = {
  fontSize: {
    xs: "14px",
    sm: "15px",
    md: "16px",
  },
  lineHeight: "30px",
  color: "#333",
  fontFamily: "LatoGoogle,Lato,LatoWeb,sans-serif",
  mb: 2,
};

const listStyle = {
  paddingLeft: "20px",
  lineHeight: "35px",
  color: "#333",
  fontFamily: "LatoGoogle,Lato,LatoWeb,sans-serif",
};

export default PrivacyPolicy;